import type { SummaryInfoDisplayProps } from "@pharmupp/p3-front-commons"
import {
  type NewsStatusesName,
  laboratoryNewsStatusesEnum,
  newsStatusesEnum,
} from "../../commons"

export type NewsSummaryInfoDisplayProps = Omit<
  SummaryInfoDisplayProps,
  "onClick" | "count"
>

const defaultSummaryBanner: Omit<NewsSummaryInfoDisplayProps, "label"> = {
  baseColor: "success.main",
  variant: "outlined",
}

export const newsSummaryBannerChips: Record<
  NewsStatusesName,
  NewsSummaryInfoDisplayProps
> = {
  PUBLISHED: {
    label: newsStatusesEnum.PUBLISHED.label,
    baseColor: "success.main",
    variant: "filled",
  },
  WAITING: {
    label: newsStatusesEnum.WAITING.label,
    ...defaultSummaryBanner,
  },
  ARCHIVED: {
    label: newsStatusesEnum.ARCHIVED.label,
    ...defaultSummaryBanner,
  },
  DRAFT: {
    label: newsStatusesEnum.DRAFT.label,
    ...defaultSummaryBanner,
  },
  PENDING_REVIEW: {
    label: newsStatusesEnum.PENDING_REVIEW.label,
    labelColor: "common.orange",
    baseColor: "common.orange",
    variant: "filled",
  },
}

export const newsExternLabSummaryBannerChips: Record<
  NewsStatusesName,
  NewsSummaryInfoDisplayProps
> = {
  WAITING: {
    label: laboratoryNewsStatusesEnum.WAITING.label,
    ...defaultSummaryBanner,
  },
  PUBLISHED: {
    label: laboratoryNewsStatusesEnum.PUBLISHED.label,
    baseColor: "success.main",
    variant: "filled",
  },
  PENDING_REVIEW: {
    label: laboratoryNewsStatusesEnum.PENDING_REVIEW.label,
    labelColor: "common.orange",
    baseColor: "common.orange",
    variant: "outlined",
  },
  ARCHIVED: {
    label: laboratoryNewsStatusesEnum.ARCHIVED.label,
    ...defaultSummaryBanner,
  },
  DRAFT: {
    label: laboratoryNewsStatusesEnum.DRAFT.label,
    ...defaultSummaryBanner,
  },
}
